@if (isV2()) {
	<div class="solution-v2" *ngIf="loaded">
		<header class="solution-v2-header">
			<div class="solution-v2-titles">
				<h2 class="solution-v2-title">{{ "ASSIGNMENT_RESOLVE__TITLE" | transloco }}</h2>
				<p class="solution-v2-description">{{ "ASSIGNMENT_RESOLVE__SUBTITLE" | transloco }}</p>
			</div>
			<button
				type="button"
				class="solution-v2-close"
				(click)="close()"
				[attr.aria-label]="'BASE__CANCEL' | transloco"
			>
				<span class="material-symbols-outlined" aria-hidden="true">close</span>
			</button>
		</header>

		<div class="solution-v2-body" [formGroup]="formGroup">
			@if (definition && states.length > 1) {
				<label class="solution-v2-field">
					<span class="solution-v2-field-label">
						{{ "ASSIGNMENT__STATE" | transloco }}<span
							class="solution-v2-required"
							[class.solution-v2-required--invalid]="
								formGroup.controls.definitionState.invalid &&
								formGroup.controls.definitionState.touched
							"
							aria-hidden="true"
							>*</span
						>
					</span>
					<ion-select
						fill="outline"
						formControlName="definitionState"
						[placeholder]="'ASSIGNMENT__STATE_EMPTY' | transloco"
						(ionChange)="changeState($event)"
						[compareWith]="compareWith"
					>
						<ion-select-option *ngFor="let state of states" [value]="state">
							{{ state.name }}
						</ion-select-option>
					</ion-select>
				</label>
			}

			<label class="solution-v2-field">
				<span class="solution-v2-field-label">{{ "ASSIGNMENT_RESOLVE__DESCRIPTION" | transloco }}</span>
				<ion-textarea
					class="solution-v2-textarea"
					formControlName="description"
					autoGrow="true"
					fill="outline"
					rows="4"
				></ion-textarea>
			</label>

			<div class="solution-v2-field">
				<span class="solution-v2-field-label">{{ "ASSIGNMENT_RESOLVE__ATTACHMENTS" | transloco }}</span>
				<app-attachments
					formControlName="attachments"
					[showAttachments]="true"
					[v2]="true"
					[hideHeadline]="true"
				></app-attachments>
			</div>
		</div>

		<footer class="solution-v2-footer">
			<button type="button" class="solution-v2-btn solution-v2-btn--ghost" (click)="close()">
				{{ "BASE__CANCEL" | transloco }}
			</button>
			<button
				type="button"
				class="solution-v2-btn solution-v2-btn--primary"
				[disabled]="formGroup.invalid"
				(click)="save()"
			>
				{{ "ASSIGNMENT_RESOLVE__RESOLVE" | transloco }}
			</button>
		</footer>
	</div>
} @else {
	<ion-header>
		<ion-toolbar>
			<ion-title>{{ "ASSIGNMENT_RESOLVE__TITLE" | transloco }}</ion-title>
			<ion-buttons slot="end">
				<ion-button (click)="close()">
					<ion-icon slot="icon-only" name="close-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
	</ion-header>

	<ion-content>
		<ion-text>
			<p class="ion-padding-start ion-padding-end">
				{{ "ASSIGNMENT_RESOLVE__SUBTITLE" | transloco }}
			</p>
		</ion-text>
		<ion-list [formGroup]="formGroup">
			<ion-item *ngIf="definition && states.length > 1">
				<ion-select
					labelPlacement="stacked"
					justify="start"
					formControlName="definitionState"
					[placeholder]="'ASSIGNMENT__STATE_EMPTY' | transloco"
					label="{{ 'ASSIGNMENT__STATE' | transloco }}"
					(ionChange)="changeState($event)"
					[compareWith]="compareWith"
				>
					<ion-select-option *ngFor="let state of states" [value]="state">
						{{ state.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-textarea
					formControlName="description"
					autoGrow="true"
					labelPlacement="stacked"
					label="{{ 'ASSIGNMENT_RESOLVE__DESCRIPTION' | transloco }}"
				></ion-textarea>
			</ion-item>
			<ion-item lines="none">
				<div>
					<app-attachments formControlName="attachments" [showAttachments]="true"></app-attachments>
				</div>
			</ion-item>
		</ion-list>
	</ion-content>

	<ion-footer>
		<div class="buttons-container">
			<ion-button (click)="close()" shape="round" expand="block" color="light">
				{{ "BASE__CANCEL" | transloco }}
			</ion-button>
			<ion-button [disabled]="formGroup.invalid" (click)="save()" shape="round" expand="block">
				{{ "ASSIGNMENT_RESOLVE__RESOLVE" | transloco }}
			</ion-button>
		</div>
	</ion-footer>
}
